(function () {
  var t = document.querySelector('[data-menu-toggle]'), n = document.querySelector('[data-menu]');
  if (t && n) t.addEventListener('click', function () {
    var o = n.classList.toggle('open'); t.setAttribute('aria-expanded', o);
  });
  var s = document.querySelector('[data-sort]');
  if (s) s.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });
  var f = document.getElementById('ProductForm'), d = document.getElementById('VariantData');
  if (f && d && f.querySelector('fieldset.opt')) {
    var v = JSON.parse(d.textContent), idEl = document.getElementById('VariantId'),
        btn = document.getElementById('AddBtn'), pr = document.getElementById('ProdPrice');
    f.addEventListener('change', function () {
      var sel = [].map.call(f.querySelectorAll('fieldset.opt'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var m = v.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!m) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idEl.value = m.id; btn.disabled = !m.available;
      btn.textContent = m.available ? 'Add to cart' : 'Sold out';
      if (pr) pr.innerHTML = (m.hasCompare ? '<s>' + m.compare + '</s> ' : '') + m.price;
      var u = new URL(window.location.href); u.searchParams.set('variant', m.id);
      history.replaceState({}, '', u);
    });
  }
})();
